import React from 'react'

import './GenderBookModal.scss'
import { useTranslation } from 'react-i18next'
import ModalDialog from '@components/ModalDialog/ModalDialog'
import Markdown from '@components/Markdown/Markdown'
import Button from '@components/Button/Button'
export type GenderBookModalProps = {
  onClose: () => void
  onClickTransfer: () => void
  onClickOpen: () => void
  gender?: string
  open: boolean
}

export type GenderBookModalContentProps = {
  onClickTransfer: () => void
  onClickOpen: () => void
  gender?: string
}
export const GenderBookModalContent = ({ onClickTransfer, onClickOpen }: GenderBookModalContentProps) => {
  const { t } = useTranslation('Result')
  return (
    <div className="GenderBookModalContent">
      <Markdown content={t('genderBookModalOpenContent')} />
      <Button onClick={onClickOpen} size="small">
        {t('genderBookButtonOpenLabel')}
      </Button>
      <hr />
      <Markdown content={t('genderBookModalTransferContent')} />
      <Button onClick={onClickTransfer} size="small">
        {t('genderBookButtonTransferLabel')}
      </Button>
    </div>
  )
}
export const GenderBookModal = ({ onClose, gender, open, ...genderBookModalContentProps }: GenderBookModalProps) => {
  const { t } = useTranslation('Result')
  return (
    <ModalDialog
      title={t('genderBookButtonModalTitle', { target: gender })}
      extraClass="GenderBookContent"
      bodyComponent={<GenderBookModalContent {...genderBookModalContentProps} />}
      onClose={onClose}
      visible={open}
    />
  )
}
